/*
 * Copyright (c) 2026 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */

import semver from 'semver';

const SEMVER_EXTRACT_RE = /v?(\d+\.\d+\.\d+(?:-(?:alpha|beta|rc|dev|pre)(?:\.[0-9A-Za-z]+)*)?)/i;

export type ParsedSemver = {
    major: number;
    minor: number;
    patch: number;
    prerelease: string[];
};

export function parseSemver(version: string): ParsedSemver | null {
    const normalized = extractSemverFromText(version);
    const parsed = semver.parse(normalized);
    if (!parsed) return null;
    return {
        major: parsed.major,
        minor: parsed.minor,
        patch: parsed.patch,
        prerelease: parsed.prerelease.map((part: string | number) => String(part)),
    };
}

export function compareSemver(a: string, b: string): number {
    const av = semver.valid(extractSemverFromText(a));
    const bv = semver.valid(extractSemverFromText(b));
    if (!av && !bv) return 0;
    if (!av) return -1;
    if (!bv) return 1;
    return semver.compare(av, bv);
}

export function extractSemverFromFilename(name: string): string {
    const base = String(name || '').split(/[\\/]/).pop() || '';
    const withoutExt = base.replace(/\.(tar\.gz|dmg|exe)$/i, '');
    const m = withoutExt.match(SEMVER_EXTRACT_RE);
    return m ? m[1] : '';
}

export function extractSemverFromText(value: string | undefined): string {
    const m = String(value || '').match(SEMVER_EXTRACT_RE);
    return m ? m[1] : '';
}
